import { observable } from "mobx";

export const iframeAvailableContentHeight = observable.box(0);
